<app-banner-info [page]="'com_etic'" [title]="'ETHICS_COMMITEE.TITLE'" [subtitle]="'ETHICS_COMMITEE.INFO_SUBTITLE'">
</app-banner-info>
<!-- ALL -->
<app-main-all-body id="all-ethics-commitee" [typology]="'com_etic'" [mainTitle]="''" [bodyList]="ethicsCommiteeList">
</app-main-all-body>
<!-- END ALL -->